export default {
  auth: () => import("/app/src/layouts/auth.vue"),
  default: () => import("/app/src/layouts/default.vue"),
  fullview: () => import("/app/src/layouts/fullview.vue")
}